// extracted by mini-css-extract-plugin
export default {"valueContainer":"DescriptionCell__valueContainer___nJgTI"};